module.exports = __webpack_public_path__ + "static/img/y.40720da7.png";